import { Button } from '../../Utility/Button';
import AdminContainer from '../../Utility/AdminContainer';
import { PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react';
import useApiKeys from '../../../Hooks/useApiKeys';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import AdminViewContent from '../../Utility/AdminViewContent';
import { ApiKey } from '../../../Types';
import { PaginationListType } from '../../../Types/PaginationParams';
import { apiKeyService } from '../../../Services/apiKeyService';
import PaginatedView from '../../Utility/PaginatedView';

function ApiKeys() {
    const { ApiKeysActions, settings, i18n, getBreakpoint, windowWidth, apiKeys, handleNavigate } = useApiKeys();

    const GRID_COLS = 'grid-cols-[300px,1fr]';

    const handleEdit = (identifier: string) => {
        ApiKeysActions.handleEdit(identifier);
    };

    const handleOpenConfirmDialog = (apiKeyIdentifier: string) => {
        ApiKeysActions.handleOpenConfirmDialog(apiKeyIdentifier);
    };

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <PaginatedView
                        listType={PaginationListType.ApiKeys}
                        itemsFunction={apiKeyService.getApiKeysByPage}
                        itemsPerPage={15}
                        renderItem={(apiKey: ApiKey, index: number) => (
                            <AdminViewContent
                                key={apiKey.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={apiKey.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: apiKey.name,
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleEdit(apiKey.identifier),
                                                icon: <PencilSimpleIcon />,
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () => handleOpenConfirmDialog(apiKey.identifier),
                                                tooltipText: i18n.translate({
                                                    id: 'tooltip.deleteAssistant',
                                                    sourceName: 'Prompts',
                                                }),
                                                icon: <TrashIcon />,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    >
                        {({ list, filter }) => (
                            <>
                                {filter}
                                <div className="hidden md:block">
                                    <AdminViewHeader
                                        gridCols={GRID_COLS}
                                        cols={{
                                            cols: [
                                                {
                                                    text: i18n.translate({
                                                        id: 'adminHeader.mainCol',
                                                        sourceName: 'Main',
                                                    }),
                                                },
                                            ],
                                            button: {
                                                text: i18n.translate({ id: 'newApiKey.button', sourceName: 'ApiKeys' }),
                                                function: () => handleNavigate('new'),
                                                renderCondition: settings.apiKeyLicences > apiKeys.length,
                                            },
                                        }}
                                    />
                                    <hr className="border-layout-borderColor mt-5" />
                                </div>

                                <div className="mb-4 block md:hidden">
                                    {settings.apiKeyLicences > apiKeys.length && (
                                        <Button
                                            className="!m-0 !mb-3 flex justify-center items-center w-full"
                                            onClick={() => handleNavigate('new')}
                                        >
                                            {i18n.translate({ id: 'newApiKey.button', sourceName: 'ApiKeys' })}
                                        </Button>
                                    )}
                                </div>
                                {list}
                            </>
                        )}
                    </PaginatedView>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default ApiKeys;
